// extracted by mini-css-extract-plugin
module.exports = {"create-acc-form":"CreateAccForm_create-acc-form__3OBst","cta-wrapper":"CreateAccForm_cta-wrapper__SRMg2","submit-button":"CreateAccForm_submit-button__1u1aR"};